import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const LandmarkViewIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "LandmarkViewIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M17.9004 3.9533C18.224 3.9533 18.4863 3.69095 18.4863 3.36736V2.97673C18.4577 2.20044 17.3431 2.20044 17.3145 2.97673V3.36736C17.3145 3.69096 17.5768 3.9533 17.9004 3.9533Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M7.27539 4.69549C7.59899 4.69549 7.86133 4.43314 7.86133 4.10955V3.71892C7.83266 2.94263 6.71808 2.94263 6.68945 3.71892V4.10955C6.68945 4.43315 6.95176 4.69549 7.27539 4.69549Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M7.27539 7.42987C7.59899 7.42987 7.86133 7.16752 7.86133 6.84393V6.4533C7.83266 5.67701 6.71808 5.67701 6.68945 6.4533V6.84393C6.68945 7.16753 6.95176 7.42987 7.27539 7.42987Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M8.44696 5.86718H8.83759C9.16119 5.86718 9.42353 5.60483 9.42353 5.28124C9.42353 4.95765 9.16118 4.6953 8.83759 4.6953H8.44696C7.67067 4.72397 7.67067 5.83855 8.44696 5.86718Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M5.71259 5.86718H6.10322C6.42682 5.86718 6.68916 5.60483 6.68916 5.28124C6.68916 4.95765 6.42681 4.6953 6.10322 4.6953H5.71259C4.9363 4.72397 4.9363 5.83855 5.71259 5.86718Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.9004 5.12498C17.5768 5.12498 17.3145 5.38733 17.3145 5.71092V6.10155C17.3431 6.87784 18.4577 6.87784 18.4863 6.10155V5.71092C18.4863 5.38732 18.224 5.12498 17.9004 5.12498Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.0725 5.12499H19.4631C19.7867 5.12499 20.049 4.86264 20.049 4.53905C20.049 4.21546 19.7867 3.95311 19.4631 3.95311H19.0725C18.2962 3.98178 18.2962 5.09636 19.0725 5.12499Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.3381 5.12499H16.7287C17.0523 5.12499 17.3146 4.86264 17.3146 4.53905C17.3146 4.21546 17.0523 3.95311 16.7287 3.95311H16.3381C15.5618 3.98178 15.5618 5.09636 16.3381 5.12499Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.4316 15.9063C17.108 15.9063 16.8456 16.1687 16.8456 16.4923V17.8205H15.905V10.1056C15.905 9.78201 15.6427 9.51967 15.3191 9.51967H14.8002L12.9564 2.4383C12.8892 2.18013 12.6561 1.99998 12.3894 1.99998C12.1227 1.99998 11.8896 2.18014 11.8223 2.4383L9.97859 9.51967H9.45964C9.13604 9.51967 8.8737 9.78202 8.8737 10.1056V17.8205H7.93932V16.4923C7.91123 15.7172 6.7965 15.7148 6.76744 16.4923L6.76123 21.4141C6.76123 21.7377 7.02358 22 7.34717 22C7.67076 22 7.93311 21.7377 7.93311 21.4141V18.9924H16.8456V21.4141C16.8456 21.7377 17.1079 22 17.4315 22C17.7551 22 18.0175 21.7377 18.0175 21.4141V16.4923C18.0175 16.1687 17.7551 15.9063 17.4316 15.9063ZM12.3894 4.91137L13.5485 9.36331H11.2302L12.3894 4.91137ZM12.3894 11.7852C11.2799 11.7852 10.3415 12.5294 10.0456 13.5446V10.6916H14.7331V13.5446C14.4372 12.5294 13.4988 11.7852 12.3894 11.7852ZM13.6589 14.2266C13.6589 14.9267 13.0894 15.4962 12.3894 15.4962C10.7074 15.4323 10.7079 13.0206 12.3894 12.9571C13.0894 12.9571 13.6589 13.5266 13.6589 14.2266ZM10.0456 17.8205V14.9087C10.7419 17.2405 14.0377 17.2391 14.7331 14.9087V17.8206L10.0456 17.8205Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.4629 9.44432C19.1393 9.44432 18.877 9.70667 18.877 10.0303V10.4209C18.9056 11.1972 20.0202 11.1972 20.0488 10.4209V10.0303C20.0488 9.70666 19.7865 9.44432 19.4629 9.44432Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.4629 12.1787C19.1393 12.1787 18.877 12.441 18.877 12.7646V13.1553C18.9056 13.9316 20.0202 13.9316 20.0488 13.1553V12.7646C20.0488 12.441 19.7865 12.1787 19.4629 12.1787Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M21.0254 11.0068H20.6348C20.3112 11.0068 20.0488 11.2692 20.0488 11.5928C20.0488 11.9164 20.3112 12.1787 20.6348 12.1787H21.0254C21.8017 12.15 21.8016 11.0355 21.0254 11.0068Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.291 11.0068H17.9004C17.5768 11.0068 17.3145 11.2692 17.3145 11.5928C17.3145 11.9164 17.5768 12.1787 17.9004 12.1787H18.291C19.0673 12.15 19.0673 11.0355 18.291 11.0068Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M4.54102 12.2346C4.86462 12.2346 5.12696 11.9722 5.12696 11.6486V11.258C5.09829 10.4817 3.98371 10.4817 3.95508 11.258V11.6486C3.95508 11.9722 4.21739 12.2346 4.54102 12.2346Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M4.54102 13.4062C4.21742 13.4062 3.95508 13.6686 3.95508 13.9922V14.3828C3.98375 15.1591 5.09833 15.1591 5.12696 14.3828V13.9922C5.12696 13.6686 4.86461 13.4062 4.54102 13.4062Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M6.10352 12.2344H5.71289C5.38929 12.2344 5.12695 12.4967 5.12695 12.8203C5.12695 13.1439 5.3893 13.4062 5.71289 13.4062H6.10352C6.87981 13.3776 6.87977 12.263 6.10352 12.2344Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M3.36915 12.2344H2.97852C2.65492 12.2344 2.39258 12.4967 2.39258 12.8203C2.39258 13.1439 2.65493 13.4062 2.97852 13.4062H3.36915C4.14544 13.3776 4.14544 12.263 3.36915 12.2344Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default LandmarkViewIcon;
